// extracted by mini-css-extract-plugin
module.exports = {"valueWrapper":"styles_valueWrapper__2pjrx","value":"styles_value__2HQSt","icon":"styles_icon__hD4km"};